import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';

@Component({
    selector: 'bm-billing-area-details',
    templateUrl: 'bm-billing-area-details.component.html',
    standalone: false
})
export class BmBillingAreaDetailsComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() billingAreaId: number;

    billingAreaWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        this.billingAreaWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.billing.area.details.widget.data',
            'Abrechnungsbereich',
            'bm.BillingArea',
            this.billingAreaId
        );
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['billingAreaId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
